import React, { useEffect } from "react";
import {Link, useNavigate} from 'react-router-dom'

// @mui/material
import axios from 'axios';
import { Typography, CardContent, Button } from "@mui/material";

// core components
import GridItem from "../../components/Grid/GridItem.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import Card from "../../components/Card/Card.jsx";
import {useSelector} from 'react-redux';
import { baseUrl } from '../../components/shared/baseUrl';
import stock1 from '/assets/images/stock-photos/stock-1.jpg';
import styles from "../../components/assets/jss/material-dashboard-react/views/dashboardStyle";
import AboutComponent from "../../components/layouts/AboutComponent"
import withRouterCompat from "../../actions/routerWrapper";

function StudentHome(props) {
  const [userdata, setuserdata] = React.useState({"id":'',"token":''});

  const user = useSelector(state => state.user)
  
  useEffect(() => {
   
  setuserdata(user)

  })

  const history = useNavigate();

  const handleNext = () => {
    var classId = '6006f33eef2c0d65ccbf6601'
    axios.get(`${baseUrl}pyinterpreter/profile`)
    .then((response) => {
      ///console.log(response.data)
      
      const ses = response.data.filter((session) => session.userId === user.email)
      history(`/student/dashboard/viewstudentclass/${classId}/session/${ses[0]._id}/activitydemo`)

    })
  }

  console.log(userdata)

  return (
    <div>
        <div className="container">
          <div className="px-0 col-lg-8 col-md-10 col-sm-12 mx-auto text-center">
              <p className="display-4 mb-4 font-weight-bold">
                Helpful Resources
              </p>
              {/* <p className="font-size-lg text-black-100">
                    Helpful Resources
              </p> */}
          </div>
        </div>
                                      <div className="mt-4 text-center d-flex flex-row flex-wrap justify-content-center">
                                        <div>
                                            <div className="bg-white card card-box card-box-hover-rise px-2 pt-2 pb-3 m-3"
                                                title="Click below to see video">
                                                <b>Computational Thinking: What Is It? How Is It Used?</b>
                                                <iframe src='https://www.youtube.com/embed/qbnTZCj0ugI'
                                                    allow='autoplay; encrypted-media'
                                                    allowFullScreen={true}
                                                    title='video'
                                                />
                                            </div>
                                        </div>
                                        <div>
                                            <div className="bg-white card card-box px-2 pt-2 pb-3 m-3"
                                                title="Click below to see video">
                                                <b>Computational Thinking for Children</b>
                                                <iframe src='https://www.youtube.com/embed/mUXo-S7gzds'
                                                    allow='autoplay; encrypted-media'
                                                    allowFullScreen={true}
                                                    title='video'
                                                />
                                                {/* <i className="details-helper text-black-50">
                                                    Not yet available
                                                </i> */}
                                            </div>
                                        </div>
                                        <div>
                                            <div className="bg-white card card-box px-2 pt-2 pb-3 m-3 "
                                                title="Click below to see video">
                                                <b>What is Computational Thinking?</b>
                                                <iframe src='https://www.youtube.com/embed/kdngEhA4I00'
                                                    allow='autoplay; encrypted-media'
                                                    allowFullScreen={true}
                                                    title='video'
                                                />

                                            </div>
                                        </div>
                                        <div>
                                            <div className="card card-box px-2 pt-2 pb-3 m-3"
                                                title="Click below to see video">
                                                <b>Computational Thinking for a Computational World</b>
                                                <iframe src='https://www.youtube.com/embed/-nN6vyxa8lk'
                                                    allow='autoplay; encrypted-media'
                                                    allowFullScreen={true}
                                                    title='video'
                                                />
                                            </div>
                                        </div>
                                      </div>

        <div className="container">
          <div className="px-0 col-lg-8 col-md-10 col-sm-12 mx-auto text-center">
              <p className="display-4 mb-4 font-weight-bold">
                Example Activities
              </p>
              {/* <p className="font-size-lg text-black-100">
                    Helpful Resources
              </p> */}
          </div>
        </div>
                                        <div className="container-fluid">
                                          <GridContainer spacing={4}>
                                                <GridItem xs={12} sm={6} md={3}>
                                                    <Card>
                                                        <CardContent>
                                                            <img alt="..." className="card-img-top" src={stock1} />
                                                            <Typography gutterBottom variant="h6" component="p">
                                                                Activity 1
                                                            </Typography>
                                                            <Typography component="h5" variant="caption">
                                                                Level: Easy |
                                                                Language: English |
                                                                Subject:Computer Science |
                                                                Class:VIII
                                                            </Typography>
                                                            <Typography component="p" variant="caption">
                                                                Description: To calculate the suitable structure circle/square inside square
                                                            </Typography>
                                                        </CardContent>
                                                        <div className="card-body text-center">
                                                            <Button
                                                                size="small"
                                                                variant="outlined"
                                                                color="primary"
                                                                className="mt-1"
                                                                onClick={handleNext}>
                                                                Start Activity
                                                            </Button>
                                                        </div>
                                                    </Card>
                                                </GridItem>
                                            </GridContainer>   
                                        </div>
                                        <div className="container">
                                          <div className="px-0 col-lg-8 col-md-10 col-sm-12 mx-auto text-center">
                                              <h2 className="display-4 mb-4 font-weight-bold">
                                                About Us
                                              </h2>
                                          </div>
                                          <AboutComponent />
                                        </div>

      
     
    </div>
  );
}

export default withRouterCompat(StudentHome);
